//@flow
import React from "react"
import { Switch, Route } from "react-router-dom"
import KioskListView from "./KioskListView"
import KioskFormView from "./KioskFormView"
import type { Match } from "react-router-dom"
import queries from "./queries"
import type { Kiosk, KioskListQuery } from "./types"

const Kiosks = ({ match }: { match: Match }) => {
  return (
    <Switch>
      <Route path={`${match.url}/new`} component={KioskFormView} />
      <Route path={`${match.url}/:id`} component={KioskFormView} />
      <Route component={KioskListView} />
    </Switch>
  )
}

export { queries }

export type { Kiosk, KioskListQuery }

export default Kiosks



// WEBPACK FOOTER //
// ./src/Kiosks/index.js